<template>
  <v-container fluid>
    <v-layout xs12 align-start row wrap>
      <v-flex xs12 sm12 md12 justify-center>
        <h2 class="ml-2 mb-2">{{ titulo }}</h2>
        <v-data-table
          :headers="headers"
          :items="$apollo.data.users"
          :loading="$apollo.loading"
          item-key="id"
          class="elevation-1"
        >
          <template v-slot:top>
            <v-toolbar flat height="100">
              <div class="md8 mr-11 ml-2 row sm10 xs10">
                <v-flex xs12 sm12 md3 py-2>
                  <v-text-field
                    v-model="filters.name"
                    flat
                    hide-details
                    label="Nome"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md3 py-2 v-if="tipo == 0">
                  <ApolloQuery
                    :query="
                      gql => gql`
                        query ListRoles {
                          roles {
                            id
                            name
                          }
                        }
                      `
                    "
                  >
                    <template v-slot="{ result: { error, data } }">
                      <v-autocomplete
                        v-if="data"
                        v-model="filters.id_role"
                        v-bind:items="toArray(data.roles)"
                        id="id"
                        :error="error"
                        color="white"
                        label="Tipo de usuário"
                        item-text="name"
                        item-value="id"
                        @keyup.delete="filters.id_role = null"
                      >
                      </v-autocomplete>
                    </template>
                  </ApolloQuery>
                </v-flex>
              </div>
              <v-dialog v-model="dialog" max-width="900px">
                <template v-slot:activator="{ on }">
                  <v-btn color="primary" dark class="mb-2" v-on="on"
                    >Adicionar</v-btn
                  >
                </template>
                <v-card>
                  <v-card-title>
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-form
                        ref="form"
                        v-model="valid"
                        :lazy-validation="lazy"
                      >
                        <v-row>
                          <v-col cols="12" md="12">
                            <v-text-field
                              v-model.lazy="editedItem.name"
                              id="name"
                              label="Nome"
                              :rules="rules"
                              required
                            >
                            </v-text-field>

                            <v-text-field
                              v-model.lazy="editedItem.email"
                              id="email"
                              label="E-mail"
                              :rules="rulesEmail"
                              :error-messages="errors_email"
                              required
                            >
                            </v-text-field>

                            <v-text-field
                              v-model.lazy="editedItem.cpf"
                              id="cpf"
                              label="CPF"
                              v-mask="'###.###.###-##'"
                              :error-messages="errors_cpf"
                              :rules="rules"
                              required
                            >
                            </v-text-field>

                            <v-menu
                              v-model="menu"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                            >
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                  v-model="editedItem.birthday"
                                  label="Data de Nascimento"
                                  readonly
                                  @blur="
                                    editedItem.birthday = parseDate(
                                      dateFormated
                                    )
                                  "
                                  v-on="on"
                                  :rules="rules"
                                  required
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="editedItem.birthday"
                                @input="menu = false"
                              ></v-date-picker>
                            </v-menu>

                            <v-text-field
                              v-model.lazy="editedItem.password"
                              id="password"
                              label="Senha"
                              :rules="rules"
                              type="password"
                              required
                            >
                            </v-text-field>

                            <ApolloQuery
                              :query="
                                gql => gql`
                                  query ListRoles {
                                    roles {
                                      id
                                      name
                                    }
                                  }
                                `
                              "
                            >
                              <template v-slot="{ result: { error, data } }">
                                <v-autocomplete
                                  v-if="data"
                                  v-model="editedItem.id_role"
                                  v-bind:items="toArray(data.roles)"
                                  id="role"
                                  label="Tipo de usuário"
                                  item-text="name"
                                  item-value="id"
                                  :disabled="tipo == 3"
                                  :rules="rules"
                                  :error="error"
                                  required
                                >
                                </v-autocomplete>
                              </template>
                            </ApolloQuery>
                            <v-autocomplete
                              v-model="editedItem.users_drugstores"
                              :items="drugstores"
                              item-text="name"
                              item-value="id"
                              placeholder="Drogaria"
                              chips
                              multiple
                            >
                              <template v-slot:item="data">
                                <template v-if="data.item.id">
                                  {{ data.item.name }}
                                </template>
                              </template>
                            </v-autocomplete>
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <div class="flex-grow-1"></div>
                    <v-btn color="blue darken-1" text @click="close"
                      >Cancelar</v-btn
                    >
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="save"
                      :disabled="!valid"
                      >Salvar</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-toolbar>
          </template>
          <template v-slot:[`item.cpf`]="{ item }">
            {{ item.cpf }}
          </template>
          <template v-slot:[`item.birthday`]="{ item }">
            {{ formatDate(item.birthday) }}
          </template>
          <template v-slot:[`item.action`]="{ item }" style="width: 75px;">
            <v-icon small class="mr-2" @click="editItem(item)">edit</v-icon>
            <v-icon small @click="deleteItem(item)">delete</v-icon>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import {
  GetUsers,
  DeleteUsers,
  InsertUsers,
  UpdateUsers,
  UpdateUserDrugstore,
  DeleteUserDrugstore
} from "../../graphql/users.gql";

import { GetDrugstores } from "../../graphql/drugstore.gql";

let date = new Date();
export default {
  name: "users-list",
  props: ["tipo"],
  data: vm => ({
    errors_cpf: [],
    errors_email: [],
    drugstoresArray: [],
    dialog: false,
    valid: true,
    lazy: false,
    menu: false,
    titulo: "Usuarios",
    dateFormated: vm.formatDate(
      new Date(date.getFullYear(), date.getMonth(), 1)
        .toISOString()
        .substr(0, 10)
    ),
    filters: {
      name: null,
      id_role: null
    },
    headers: [
      { text: "Nome", value: "name" },
      { text: "E-mail", value: "email" },
      { text: "Nascimento", value: "birthday" },
      { text: "CPF", value: "cpf" },
      { text: "Tipo de Usuário", value: "role.name" },
      { text: "Ações", value: "action", sortable: false }
    ],
    editedIndex: -1,
    editedItem: {
      id: null,
      name: null,
      email: null,
      birthday: null,
      cpf: null,
      password: null,
      id_role: null,
      users_drugstores: []
    },
    defaultItem: {
      id: null,
      name: null,
      email: null,
      birthday: null,
      cpf: null,
      password: null,
      id_role: null,
      users_drugstores: []
    },
    rules: [v => !!v || "Campo obrigatório!"],
    rulesEmail: [
      v => !!v || "Campo obrigatório!",
      v => /.+@.+/.test(v) || "E-mail invalido!"
    ]
  }),

  apollo: {
    users: {
      query: GetUsers,
      variables() {
        return {
          name: this.filters.name
            ? { _ilike: "%" + this.filters.name + "%" }
            : {},
          id_role: this.filters.id_role ? { _eq: this.filters.id_role } : {}
        };
      }
    },
    drugstores: {
      query: GetDrugstores,
      variables() {}
    }
  },

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Novo Usuário" : "Editar Usuário";
    }
  },

  mounted: function() {
    if (this.tipo == 0) {
      this.titulo = "Usuarios";
      this.filters.id_role = null;
    }
    if (this.tipo == 3) {
      this.titulo = "Entregadores";
      this.filters.id_role = 3;
      this.editedItem.id_role = 3;
    }
  },

  watch: {
    "editedItem.birthday": {
      deep: true,
      handler() {
        this.dateFormated = this.formatDate(this.editedItem.birthday);
      }
    },

    tipo() {
      if (this.tipo == 0) {
        this.titulo = "Usuarios";
        this.filters.id_role = null;
      }
      if (this.tipo == 3) {
        this.titulo = "Entregadores";
        this.filters.id_role = 3;
        this.editedItem.id_role = 3;
      }
    },

    "filters.name": {
      deep: true,
      handler(val) {
        if (typeof val !== "undefined" && val !== null) {
          if (val.length == 0) {
            this.filters.name = null;
          }
        }
      }
    }
  },

  methods: {
    editItem(item) {
      this.editedIndex = this.$apollo.data.users.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.editedItem.id_role = item.role ? item.role.id : null;
      this.editedItem.users_drugstores = item.users_drugstores.map(
        item => item.id_drugstore
      );
      this.dialog = true;
    },

    deleteItem(item) {
      const index = this.$apollo.data.users.indexOf(item);
      confirm("Apagar Usuario?") &&
        this.$apollo.data.users.splice(index, 1) &&
        this.$apollo
          .mutate({
            mutation: DeleteUsers,
            variables: {
              id: item.id
            }
          })
          .then(() => {
            this.$swal("Usuário apagado com sucesso!", "", "success");
          })
          .catch(() => {
            this.$swal("Erro ao apagar o usuário!", "", "error");
          });
    },

    close() {
      this.dialog = false;
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
    },

    save() {
      let variables = {
        name: this.editedItem.name,
        password: this.editedItem.password,
        email: this.editedItem.email,
        birthday: this.editedItem.birthday,
        cpf: this.editedItem.cpf.replace(/\.|-/g, ""),
        id_role: this.editedItem.id_role
      };

      if (this.editedItem.id !== null) variables.id = this.editedItem.id;

      this.$apollo
        .mutate({
          // Query
          mutation: this.editedItem.id !== null ? UpdateUsers : InsertUsers,
          // Parameters
          variables: {
            name: this.editedItem.name,
            password: this.editedItem.password,
            email: this.editedItem.email,
            birthday: this.editedItem.birthday,
            cpf: this.editedItem.cpf.replace(/\.|-/g, ""),
            id_role: this.editedItem.id_role
          }
        })
        .then(async data => {
          if (this.editedItem.id !== null) {
            await Object.assign(
              this.$apollo.data.users[this.editedIndex],
              data.data.update_users.returning[0]
            );
          } else {
            await this.$apollo.data.users.push(
              data.data.insert_users.returning[0]
            );
            console.log(data.data.insert_users.returning[0].id);
            this.editedItem.id = await data.data.insert_users.returning[0].id;
          }

          //if (this.editedItem.users_drugstores.length > 0) {
          let object = await this.editedItem.users_drugstores.map(item => {
            return {
              id_user: this.editedItem.id,
              id_drugstore: item
            };
          });

          if (this.editedItem.id)
            this.$apollo.mutate({
              mutation: DeleteUserDrugstore,
              variables: { id_user: this.editedItem.id }
            });

          if (this.editedItem.users_drugstores.length > 0)
            this.$apollo.mutate({
              mutation: UpdateUserDrugstore,
              variables: { object: object }
            });
          //}

          this.close();
          this.$swal("Usuário salvo com sucesso!", "", "success");
        })
        .catch(error => {
          console.log(error);
          this.close();
          this.$swal("Erro ao salvar o usuário!", "", "error");
        });
    },

    updateDrugstore(e) {
      this.$apollo
        .mutate({
          mutation: UpdateUserDrugstore,
          variables: {
            id_user: this.editedItem.id,
            id_drugstore: e
          }
        })
        .then(() => this.$swal("Drogaria alterado com sucesso", "", "success"));
    },

    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },

    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },

    toArray(array) {
      let items = [];
      array.forEach(v => items.push(v));
      return items;
    }
  }
};
</script>

<style lang="stylus"></style>
